import request from '@/util/request'
//维保 增删改查
export function apiGetList (param) { // 列表
  return request({
    url: `/maintain-s/maintenance/records`,
    method: 'get',
    params:param
  })
}

export function insert(data){//增
	 return request({
        url: `/maintain-s/maintenance/records`,
    method: 'post',
    data
  })
}

export function del(id) { //删除
  return request({
    url: `/maintain-s/maintenance/records/${id}`,
    method: 'delete'
  })
}
export function update(data) { //改
  return request({
    url: `/maintain-s/maintenance/records`,
    method: 'put',
    data
  })
}

export function get(id) { // 查
  return request({
    url: `/maintain-s/maintenance/records/${id}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/maintain/maintenance/list.js